import { useTranslation } from 'react-i18next';

import {
  WorkforceDistributionTabs,
  WorkforceHeader,
  WorkforceSectionContainer,
} from '@/modules/home';

import PartialCircle from '~/images/shared/PartialCircle.svg';
const TAB_QUERY_INDICATOR = 'workforce-distribution';

const WorkforceDistribution = () => {
  const { t } = useTranslation('common');
  return (
    <WorkforceSectionContainer>
      <WorkforceHeader
        title={t('workforce-distribution')}
        tabsList={[
          { label: t('operations'), key: 'operations' },
          { label: t('work-locations'), key: 'fields' },
        ]}
        icon={<PartialCircle />}
        defaultValue='operations'
        tabQueryIndicator={TAB_QUERY_INDICATOR}
      />
      <WorkforceDistributionTabs />
    </WorkforceSectionContainer>
  );
};
export { WorkforceDistribution };
